export const getStyles = () => ({
  animationContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
});

export const getStylesForFluentUi = mobileDeviceQuery => ({
  newVersionTitle: {
    root: {
      textAlign: 'center',
    },
  },
  description: {
    root: {
      marginTop: 16,
      maxWidth: 800,
      textAlign: 'center',
    },
  },
  animationImage: {
    root: {
      minHeight: 240,
      marginTop: 34,
    },
    image: {
      maxHeight: 310,
      [mobileDeviceQuery]: {
        width: '100%',
      },
    },
  },
  animationLabel: {
    root: {
      textAlign: 'center',
      fontSize: 16,
      fontWeight: 'normal',
    },
  },
});
